




























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
class PageReadListRequest extends PageRequest {
  pressureId: string;
  startTime: string;
  endTime: string;
}
@Component({
  components: {},
})
export default class PressureList extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) pressureId: string;
  pagerequest: PageReadListRequest = new PageReadListRequest();
  create() { }
  created() {
    this.pagerequest.startTime = Moment()
      .add(-7, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
  }
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = val[0];
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  get list() {
    return this.$store.state.pressurerecord.list;
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.getpage();
  }
  data() {
    return {
      arealist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  pageChange(page: number) {
    this.$store.commit("pressurerecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("pressurerecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "pressurerecord/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.pressurerecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.pressurerecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.pressurerecord.currentPage;
  }
  get loading() {
    return this.$store.state.pressurerecord.loading;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("PressureId"),
      key: "pressureId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.pressureId,
            },
          },
          params.row.pressureId
        );
      },
    },
    {
      title: this.L("GatherTime"),
      key: "gatherTime",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.gatherTime == null
            ? ""
            : Moment(params.row.gatherTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("LastReportTime"),
      key: "reportTime",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.reportTime == null
            ? ""
            : Moment(params.row.reportTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("GatherInterval"),
      key: "gatherInterval",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("PressureValue"),
      key: "pressureValue",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("TemperatureValue"),
      key: "temperatureValue",
      width: 130,
      sortId: 9,
    },
    {
      title: this.L("LiquidLevelValue"),
      key: "liquidLevelValue",
      width: 130,
      sortId: 10,
    },
    {
      title: this.L("MaxValue"),
      key: "maxValue",
      width: 130,
    },
    {
      title: this.L("MinValue"),
      key: "minValue",
      width: 130,
    },
    {
      title: this.L("SaveTime"),
      key: "saveTime",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.saveTime == null
            ? ""
            : Moment(params.row.saveTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Unit"),
      key: "unitName",
      width: 130,
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      width: 130,
    },
  ];
  @Watch("pressureId")
  getitemId() {
    this.pagerequest.pressureId = this.pressureId;
  }
}
